import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageHeader from "../../../components/PageHeader";
import HowItWorksButton from "../../../components/howItWorks/HowItWorksButton";
import ContainerSettings from "../zones/ContainerSettings";
import { clearZoneCreateDraft } from "../zones/zoneCreateDraft";

const SettingsContainersList = ({ token, API, basePath }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className="settings-page-wrapper">
      <PageHeader
        title={t("Analysis Zones")}
        showBackButton={true}
        backRoute="/settings"
        backLabel={t("Back to Settings")}
        helpButton={<HowItWorksButton topic="zones" />}
      />
      <div className="settings-content-wrapper">
        <div className="settings-list-shell">
          <ContainerSettings
            token={token}
            API={API}
            onCreateZone={() => {
              clearZoneCreateDraft();
              history.push(`${basePath}/new`);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SettingsContainersList;
